import React, { FC } from 'react';
import { FormControl, FormHelperText, FormLabel, InputBase } from '@mui/material';
import styled from '@emotion/styled';
import { useContentContext } from '@qbe/dfc-content';
import { useContentComplaintPartners } from 'utils/content';

const FlexColumn = styled.div`
  flex-direction: column;
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  & > div > input {
    padding: 0;
  }
`;

const CustomFormControl = styled(FormControl)`
  flex-direction: column;
  margin-block: 0;
`;

type ChangeType = React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;

type FieldType = {
  name: string;
  age: string;
};

type FieldValues = {
  name: unknown;
  age: unknown;
};

type ChangeEvent = {
  onChangeName?: ChangeType;
  onChangeAge?: ChangeType;
};

type Props = {
  fieldNames: FieldType;
  defaultValues: FieldValues;
  errors: FieldType;
  changeEvents: ChangeEvent;
};

const DependentItem: FC<Props> = (props) => {
  const { fieldNames, defaultValues, changeEvents, errors } = props;

  // this focus stuff was used before but not using it right now
  // left it here in case we need it
  const [isNameFocused, setIsNameFocused] = React.useState<boolean>(false);
  const [isAgeFocused, setIsAgeFocused] = React.useState<boolean>(false);
  const [touched, setTouched] = React.useState<boolean>(false);

  const { getTextContent } = useContentComplaintPartners({
    context: useContentContext(),
  });
  return (
    <>
      <FlexColumn>
        <CustomFormControl>
          <FieldContainer>
            <>
              <FormLabel>{getTextContent('fha.insured.customer.dependentItem.name')}</FormLabel>
              <InputBase
                inputProps={{
                  maxLength: 100,
                  'aria-label': 'naked',
                }}
                name={fieldNames.name}
                defaultValue={defaultValues.name}
                error={!!errors.name}
                data-track={fieldNames.name}
                data-track-value="mask"
                onChange={changeEvents.onChangeName}
                onFocus={() => setIsNameFocused(true)}
                onBlur={() => {
                  setIsNameFocused(false);
                  setTouched(true);
                }}
                aria-describedby="name-error"
              />
            </>
          </FieldContainer>

          <FormHelperText id="name-error" error={touched && !!errors.name}>
            {touched && !!errors.name ? errors.name : ''}
          </FormHelperText>
        </CustomFormControl>
      </FlexColumn>

      <FlexColumn>
        <CustomFormControl>
          <FieldContainer>
            <>
              <FormLabel>{getTextContent('fha.insured.customer.dependentItem.age')}</FormLabel>
              <InputBase
                inputProps={{
                  maxLength: 3,
                  'aria-label': 'naked',
                }}
                name={fieldNames.age}
                defaultValue={defaultValues.age}
                data-track={fieldNames.age}
                data-track-value="mask"
                error={!!errors.age}
                onChange={changeEvents.onChangeAge}
                onFocus={() => setIsAgeFocused(true)}
                onBlur={() => {
                  setIsNameFocused(false);
                  setTouched(true);
                }}
                aria-describedby="age-error"
              />
            </>
          </FieldContainer>

          <FormHelperText id="age-error" error={touched && !!errors.age}>
            {touched && !!errors.age ? errors.age : ''}
          </FormHelperText>
        </CustomFormControl>
      </FlexColumn>
    </>
  );
};

export default DependentItem;
